import { AccordionElement } from '@typedream/core';
import { setNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { DreamEditor } from '../../../types';

export const setAccordionStyle = (
  editor: DreamEditor,
  style: NonNullable<AccordionElement['style']>,
  options: { at: Path },
) => {
  setNodes(editor, { style }, options);
};
